import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslocoModule } from '@ngneat/transloco';
import { MatButtonModule } from '@angular/material/button';

import { ProductDetailComponent } from './product-detail.component';
import { ProductDetailRoutingModule } from './product-detail-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { ProductAttributesComponent } from './product-attributes/product-attributes.component';
import { ProductTechnicalAttributesComponent } from './product-technical-attributes/product-technical-attributes.component';
import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [ProductDetailComponent, ProductAttributesComponent, ProductTechnicalAttributesComponent],
  imports: [CommonModule, ProductDetailRoutingModule, TranslocoModule, SharedModule, MatButtonModule, MatListModule],
})
export class ProductDetailModule {}
